import { useState } from "react";

import { getHeaders, URI_API } from "../../utils/config";

export function useConfirmDeleteModal() {
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const onDeleteAssignedFunctions = async (selectedRows: string[]) => {
		if (selectedRows.length === 0) return;

		setIsLoading(true);

		const requests: Promise<Response>[] = selectedRows.map((selectedNurse: string) =>
			fetch(`${URI_API}/assigned_functions`, getHeaders("DELETE", { id: selectedNurse })),
		);

		await Promise.all(requests).then((_) => {
			setIsLoading(false);
		});
	};

	return {
		isLoading,
		onDeleteAssignedFunctions,
	};
}
